import React from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import MenuItem from 'flow/components/ui-components/MenuItem';
import useAppContext from 'flow/hooks/useAppContext';
import useExtension from 'flow/hooks/useExtension';
import useVideo from 'flow/hooks/useVideo';
import { selectChatSessionByChatUser } from 'flow/selectors/chat-selectors';
import { selectOwnExtensionKey } from 'flow/selectors/ExtensionSelectors';
import { ExtensionKey } from 'flow/types/EntityKeys';

interface Props {
    extensionKey: ExtensionKey;
}

const VideoCallButtonMenuItem = ({ extensionKey }: Props) => {
    const { i18next } = useAppContext();
    const { extension, status } = useExtension(extensionKey);
    const ownExtensionKey = useAppSelector(selectOwnExtensionKey);
    const { startVideoCall } = useVideo(extensionKey);

    const chatSessionKey = useAppSelector((state) =>
        selectChatSessionByChatUser(
            state,
            extension?.get('chatUserKey'),
            ownExtensionKey,
        ),
    );

    return (
        <MenuItem
            disabled={status !== 'available'}
            onClick={() => startVideoCall(chatSessionKey)}
        >
            {i18next.t('Tooltip.Title.StartVideo')}
        </MenuItem>
    );
};

export default VideoCallButtonMenuItem;
